import Button from 'components/atoms/Button';
import Typography from 'components/atoms/Typography';
import WysiwygEditor from 'components/atoms/WysiwygEditor';
import { ActionType } from 'pages/_AdminAuthoringPages/AdminHubAuthoring/action';
import { HubAuthoringContext, HubAuthoringDispatchContext } from 'pages/_AdminAuthoringPages/AdminHubAuthoring/reducer';
import { ChangeEvent, useContext } from 'react';
import Input from 'components/molecules/Input';
import HubDiscoverControls from './HubDiscoverControls';
import HubAuthoringHeaderMedia from './HubsAuthoringHeaderMedia';

const HubAuthoringHeader = () => {
  const state = useContext(HubAuthoringContext);
  const dispatch = useContext(HubAuthoringDispatchContext);

  return (
    <div>
      <div className="card shadow-sm rounded-xl bg-white flex p-0">
        <div className="flex-column w-3/4 p-4">
          <Typography className="text-sm text-glooCharcoal font-semibold" variant="h3">
            Header
          </Typography>
          {!state.isHeaderMinimized && (
            <div>
              <HubAuthoringHeaderMedia
                header="Partner Logo"
                required
                subHeader="Upload your logo below. It will be displayed on top of the thumbnail."
                previewWidth={200}
                existingImg={state.hubUpsertParams.logoImageUrl}
                handleImgSelect={(imgUrl) => {
                  dispatch({
                    type: ActionType.setLogoImageUrl,
                    payload: imgUrl,
                  });
                }}
                error={state.errors.logoImageUrl}
              />
              <Input
                label="Title"
                required
                placeholder="Input Text Here"
                subLabel="This will be the name of the Hub. (Max 60 characters)"
                maxLength={60}
                characterLimit={60}
                value={state.hubUpsertParams.title}
                error={state.errors.title}
                onChange={(event: ChangeEvent<HTMLInputElement>) => {
                  dispatch({
                    type: ActionType.setTitle,
                    payload: event.target.value,
                  });
                }}
              />
              <HubAuthoringHeaderMedia
                header="Hero Image / Video"
                required
                subHeader="Apect Ratio: 16W : 9H. Minimum of 1000px wide."
                previewWidth={600}
                existingImg={state.hubUpsertParams.headerImageUrl}
                handleImgSelect={(imgUrl) => {
                  dispatch({
                    type: ActionType.setHeaderImageUrl,
                    payload: imgUrl,
                  });
                }}
                error={state.errors.headerImageUrl}
              />
              <HubAuthoringHeaderMedia
                header="Thumbnail Image"
                required
                subHeader="Upload your image below (228W x 126H pixels). This will display on the Hub card."
                previewWidth={200}
                existingImg={state.hubUpsertParams.thumbnailImageUrl}
                handleImgSelect={(imgUrl) => {
                  dispatch({
                    type: ActionType.setThumbnailImageUrl,
                    payload: imgUrl,
                  });
                }}
                error={state.errors.thumbnailImageUrl}
              />
              <Input
                label="Short Description"
                placeholder="Input Text Here"
                subLabel="This will be displayed on the card. (Max 72 characters)"
                isMultiLine
                characterLimit={72}
                maxLength={72}
                value={state.hubUpsertParams.shortDescription}
                onChange={(event: ChangeEvent<HTMLInputElement>) => {
                  dispatch({
                    type: ActionType.setShortDescription,
                    payload: event.target.value,
                  });
                }}
              />
              <div className="mt-4">
                <Input
                  required
                  label="Author"
                  placeholder="Input Text Here"
                  subLabel="This will be content provider. (Max 40 characters)"
                  maxLength={40}
                  characterLimit={40}
                  error={state.errors.author}
                  value={state.hubUpsertParams.author}
                  onChange={(event: ChangeEvent<HTMLInputElement>) => {
                    dispatch({
                      type: ActionType.setAuthor,
                      payload: event.target.value,
                    });
                  }}
                />
              </div>
              <WysiwygEditor
                className="mb-6"
                height={400}
                titleText="Long Description"
                subtitleText="This will be displayed in the header. Tip: This text area supports markdown formatting. (Max 480 Characters)"
                resources={undefined}
                value={state.hubUpsertParams.longDescription}
                onChange={(value) => {
                  dispatch({
                    type: ActionType.setLongDescription,
                    payload: value,
                  });
                }}
              />
            </div>
          )}
        </div>
        {!state.isHeaderMinimized && (
          <div className="border-l border-blackDarkest">
            <HubDiscoverControls />
          </div>
        )}
      </div>
      <div className="flex justify-center items-center mt-2 mb-6">
        <Button
          size="no-padding"
          className="text-glooBlue-600 underline hover:text-glooNavy-700"
          dataDurableId="minimizeAuthoringHeader"
          onClick={() => {
            dispatch({
              type: ActionType.setIsHeaderMinimized,
            });
          }}
        >
          {state.isHeaderMinimized ? 'Expand Header' : 'Minimize Header'}
        </Button>
      </div>
    </div>
  );
};

export default HubAuthoringHeader;
